module.exports = __webpack_public_path__ + "static/media/Data_COMO_INVESTIR_EM_ACOES_DE_FORMA_SEGURA.2d5f72dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/acoes/Data_COMO_INVESTIR_EM_ACOES_DE_FORMA_SEGURA.png
// module id = 74
// module chunks = 0